import * as React from "react";
import { Slider, Stack, Typography } from "@mui/material";

export function CustomSlider({ field, dynamicField }: { field: any; dynamicField: any }) {
	return (
		<Stack direction="column" alignItems="center" mt={1}>
			<Slider
				{...field}
				min={dynamicField.min}
				max={dynamicField.max}
				step={dynamicField.step}
				valueLabelDisplay="auto"
				defaultValue={dynamicField.defaultValue}
				// slots={{
				// 	valueLabel: ValueLabelComponent,
				// }}
				valueLabelFormat={(value) => `${value}`}
				sx={{
					"& .MuiSlider-valueLabel": {
						opacity: 1,
            backgroundColor: 'primary.main',
						py: 0,
						px: 0.5,
					},
				}}
			/>
			<Stack direction="row" alignItems="center" spacing={2} justifyContent="space-between" width="100%">
				<Typography variant="caption" color="text.secondary">
					{dynamicField.min}
				</Typography>
				<Typography variant="caption" color="text.secondary">
					{dynamicField.max}
				</Typography>
			</Stack>
		</Stack>
	);
}
